import React from 'react';
import { stats, partners } from '../data/mock';
import { Reveal, CountUp } from './motion';

const StatsSection = () => (
  <section className="py-7 bg-[var(--surface)] relative overflow-hidden">
    <div className="max-w-6xl mx-auto px-6">
      <dl className="grid grid-cols-2 lg:grid-cols-4 gap-y-12">
        {stats.map((s, i) => (
          <Reveal key={s.label} delay={i * 100} className={`px-6 ${i % 2 ? 'border-l border-[var(--line)]' : ''} ${i > 0 ? 'lg:border-l lg:border-[var(--line)]' : ''}`}>
            <dd className="font-display text-6xl sm:text-7xl text-[var(--paper)]"><CountUp value={s.value} /></dd>
            <dt className="font-mono-label text-[var(--muted)] mt-3">{s.label}</dt>
          </Reveal>
        ))}
      </dl>
    </div>
    <div className="mt-8 overflow-hidden" aria-label="Technology partners">
      <p className="text-center font-mono-label text-[var(--muted)] mb-6">Certified with the platforms you trust</p>
      <div className="marquee" style={{ animationDuration: '35s' }}>
        {[...partners, ...partners, ...partners, ...partners].map((p, i) => (
          <img key={i} src={p.logo} alt={i < partners.length ? p.name : ''} className="h-10 mx-12 w-auto opacity-50 hover:opacity-100 transition-opacity partner-logo" />
        ))}
      </div>
    </div>
  </section>
);

export default StatsSection;
